module.exports = __webpack_public_path__ + "img/ec.fa3c01b.png";